import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import {AutoTranslate} from "@/lib/autoTranslate.tsx"

export default function Success() {
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Check and update subscription status after successful payment
      checkSubscriptionStatus();
    }
  }, [user]);

  const checkSubscriptionStatus = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('check-subscription');
      if (error) throw error;

      // Force refresh of user profile after subscription update
      await supabase.auth.refreshSession();
      setIsUpdatingProfile(false);
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsUpdatingProfile(false);
    }
  };

  if (isUpdatingProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-main p-6">
        <Card className="max-w-md mx-auto text-center bg-card/80 backdrop-blur-sm border-card-border">
          <CardContent className="py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">{AutoTranslate("Activating your Pro account...")}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-main p-6">
      <Card className="max-w-md mx-auto text-center bg-card/80 backdrop-blur-sm border-card-border">
        <CardHeader>
          <CardTitle className="text-2xl text-green-600">{AutoTranslate("Payment Successful!")}</CardTitle>
          <CardDescription>
            {AutoTranslate("Welcome to Pro! Your subscription is now active.")}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            {AutoTranslate("You now have access to all Pro features including unlimited saved resumes, priority support, and more.")}
          </p>

          <Button
            onClick={async () => {
              // Force final subscription check before redirect
              await checkSubscriptionStatus();
              window.location.href = '/saved-resumes';
            }}
            className="w-full"
          >
            {AutoTranslate("Start Building")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}